// Component for pasting HTML text
import React, { useState } from 'react';
import { Box, TextField, Button } from '@mui/material';

const HtmlTextInput = ({ onHtmlContent }: { onHtmlContent: (content: string) => void }) => {
  const [text, setText] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
  };

  const handleApply = () => {
    onHtmlContent(text);
  };

  const handleClear = () => {
    setText('');
    onHtmlContent('');
  };

  return (
    <Box>
      <TextField
        fullWidth
        multiline
        rows={4}
        size="small"
        variant="outlined"
        placeholder="Paste HTML code here"
        value={text}
        onChange={handleChange}
        sx={{ fontFamily: 'monospace', fontSize: '0.8rem', mb: 1.5 }}
      />

      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button variant="contained" size="small" onClick={handleApply} disabled={!text}>
          Preview
        </Button>
        <Button variant="outlined" size="small" onClick={handleClear} disabled={!text}>
          Clear
        </Button>
      </Box>
    </Box>
  );
};

export default HtmlTextInput;
